import * as React from 'react';
import { Link } from 'react-router';
import styled, { css, withTheme } from 'styled-components';
import { rem, darken } from 'polished';
import { TextP } from '../../Defaults/Text';
import {
  FlexCol,
  FlexBetween,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TableTd, TableRow, DefaultTableTd } from '../General/Table';
import {
  getInvoiceDetailInfo,
  getOrderRowInfo,
} from '../../../utilities/selectors';
import { SvgIcon, IconType } from '../General/SvgIcon';
import { InvoiceRow as InvoiceTableTd } from './InvoiceTableTd';

export const getOrderColor = (status, theme): string => {
  switch (status) {
    case 'Zrušená':
      return theme.colors.danger;

    case 'INPROGRESS':
      return theme.colors.black;

    case 'DONE':
      return theme.colors.primary;

    case 'Prijatá':
      return theme.colors.success;

    default:
      return theme.colors.black;
  }
};

export interface Props {
  order: any;
  theme: any;
  download: (publicId) => void;
}

function OrderRow({ order, theme, download }: Props) {
  const { id, date, status, sumPrice, ordernr, url } = getOrderRowInfo(order);
  const color = getOrderColor(status, theme);

  return (
    <StyledTableRow>
      <StyledTableTd>
        <LinkToRequest to={url}>{ordernr}</LinkToRequest>
      </StyledTableTd>
      <StyledTableTd>
        <StatusText>{date}</StatusText>
      </StyledTableTd>
      <StyledTableTd>
        <StatusText textAlign="right">{`${sumPrice} €`}</StatusText>
      </StyledTableTd>
      <InvoiceTableTd
        showInvoice={order.invoice_number && order.invoice_number !== ''}
        download={download}
        theme={theme}
        publicId={order.public_id}
      />
      <StatusTd>
        <StatusText color={color}>
          {status === 'Zrušená' && (
            <>
              <SvgIcon
                icon={IconType.xSmall}
                alt={__('Zrušená')}
                width={12}
                height={12}
                viewBox="0 0 14 14"
                marginRight={8}
                fill={'#EB676C'}
              />
            </>
          )}
          {status === 'Prijatá' && (
            <>
              <SvgIcon
                icon={IconType.checked}
                alt={__('Prijatá')}
                width={12}
                height={12}
                viewBox="0 0 12 12"
                marginRight={8}
                fill={'#A5BBA2'}
              />
            </>
          )}
          {status}
        </StatusText>
      </StatusTd>
      {/* <StatusTd>
        <SvgIcon
          cursor={'pointer'}
          width={24}
          height={24}
          icon={IconType.refresh}
          alt="Aktualizovať"
          title="Aktualizovať"
          fill={theme.colors.textPrimary}
        />
      </StatusTd> */}
    </StyledTableRow>
  );
}

const StyledTableRow = styled(TableRow)`
  padding: ${rem(24)} 0;
  border-bottom: ${rem(2)} solid #eeeeee;

  &:last-child {
    border-bottom: none;
  }
`;

const textLikeCss = css`
  font-family: ${({ theme }) => theme.font.primary};
  font-weight: 300;
  font-size: ${rem(14)};
  line-height: ${rem(18)};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: 0;
`;

const LinkToRequest = styled(Link)`
  ${textLikeCss};
  font-weight: 500;
  text-decoration: underline;
`;

const StyledTableTd = styled(TableTd)`
  ${textLikeCss};
  padding: ${rem(18)} 0;
  padding-right: ${rem(56)};
`;

const StatusTd = styled(StyledTableTd)`
  ${textLikeCss};
`;

const StatusText = styled.p<{ color?: string; textAlign?: string }>`
  ${textLikeCss};
  font-weight: ${({ theme, color }) => (color ? 500 : 300)};
  color: ${({ theme, color }) => (color ? color : theme.colors.textPrimary)};
  text-align: ${({ textAlign }) => (textAlign ? textAlign : 'left')};

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  svg {
    vertical-align: baseline;
  }
`;

const WithThemeRow: any = withTheme(OrderRow);
export { WithThemeRow as OrderRow };
